<template>
  <settings-page-layout
      :is-loading="isLoading"
      :toolbar-title="isEdit ? 'pages.mods.branch.title.edit' : 'pages.mods.branch.title.create'"
      :progress-bar-loading="isLoading === 'branch'"
      :toolbar-buttons="isEdit ? toolbarButtons : []">
    <v-form
        ref="form"
        v-model="valid">
      <v-text-field
          v-model="name"
          :rules="nameRules"
          :label="$t('pages.mods.branch.fields.name.label')"
          :hint="$t('pages.mods.branch.fields.name.hint')"
          :disabled="isLoading != null"
          prepend-icon="mdi-form-textbox"
          required
      ></v-text-field>
      <v-checkbox
          v-model="isPublic"
          :label="$t('pages.mods.branch.fields.isPublic.label')"
          hide-details
      ></v-checkbox>
      <v-checkbox
          v-model="overwriteDirectoryName"
          :label="$t('pages.mods.branch.fields.overwriteDirectoryName.label')"
          hide-details
      ></v-checkbox>
      <v-text-field
          v-model="directoryName"
          :rules="directoryNameRules"
          :label="$t('pages.mods.branch.fields.directoryName.label')"
          :hint="$t('pages.mods.branch.fields.directoryName.hint')"
          :disabled="isLoading != null || overwriteDirectoryName != true"
          prepend-icon="mdi-folder-outline"
          required
      ></v-text-field>
      <v-checkbox
          v-model="overwriteProjectName"
          :label="$t('pages.mods.branch.fields.overwriteProjectName.label')"
          hide-details
      ></v-checkbox>
      <v-text-field
          v-model="projectName"
          :rules="projectNameRules"
          :label="$t('pages.mods.branch.fields.projectName.label')"
          :hint="$t('pages.mods.branch.fields.projectName.hint')"
          :disabled="isLoading != null || overwriteProjectName != true"
          prepend-icon="mdi-form-textbox"
          required
      ></v-text-field>
      <user-input-list
          v-model="authorizedUsers"
          list-title="pages.mods.branch.fields.authorizedUsers.header"
          :disabled="isLoading != null || isPublic == true"
          class="mt-2"></user-input-list>
      <v-row justify="end" class="mt-2">
        <v-col class="text-right">
          <v-btn
              class="mr-2"
              :disabled="isLoading != null"
              color="secondary"
              @click="cancel">
            {{ $t('pages.mods.branch.buttons.cancel') }}
          </v-btn>
          <v-btn
              :disabled="!valid || isLoading != null"
              :loading="isLoading === 'save'"
              color="success"
              @click="save">
            {{ $t(isEdit ? 'pages.mods.branch.buttons.save' : 'pages.mods.branch.buttons.create') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </settings-page-layout>
</template>

<script>
import SettingsPageLayout from "@/components/SettingsPageLayout";
import {AlertService} from "@/services/AlertService";
import UserInputList from "@/components/UserInputList";
import {ModsService} from "@/services/ModsService";

export default {
  name: "ModBranchView",
  components: {UserInputList, SettingsPageLayout},
  data(){
    return{
      isLoading: null,

      toolbarButtons: [
        {
          isDisabled: l => l != null,
          isLoading: l => l === 'branch',
          onClick: this.loadBranch,
          icon: 'mdi-refresh',
          text: 'pages.mods.branch.toolbar.refresh'
        }
      ],

      valid: true,

      name: '',
      nameRules: [
        v => !!v || this.$t('pages.mods.branch.fields.name.errors.required')
      ],
      isPublic: false,
      authorizedUsers: [],
      overwriteDirectoryName: false,
      directoryName: null,
      directoryNameRules: [],
      overwriteProjectName: false,
      projectName: null,
      projectNameRules: []
    }
  },

  computed: {
    isEdit(){
      return this.$route.params.branchId != null;
    }
  },

  methods: {
    loadBranch(){
      if(!this.isEdit) return

      this.isLoading = 'branch'
      AlertService.clearAlert();
      ModsService.getBranch(this.$route.params.modId, this.$route.params.branchId).then(branch => {
        this.$log.info('Loaded branch:',branch)
        this.name = branch.name
        this.isPublic = branch.isPublic
        this.authorizedUsers = branch.authorizedUserIds
        this.directoryName = branch.directoryName
        this.overwriteDirectoryName = branch.directoryName != null
        this.projectName = branch.projectName
        this.overwriteProjectName = branch.projectName != null
      }).catch(() => {
        AlertService.displayAlert('error', 'pages.mods.branch.messages.failedToLoad', 0)
      }).finally(() => {
        this.isLoading = null;
      })
    },
    save(){
      this.isLoading = 'save'
      AlertService.clearAlert();

      const data = {
        name: this.name,
        isPublic: this.isPublic,
        authorizedUserIds: this.authorizedUsers,
        directoryName: this.overwriteDirectoryName === true ? this.directoryName : null,
        projectName: this.overwriteProjectName === true ? this.projectName : null
      }

      const promise = this.isEdit
          ? ModsService.setBranch(this.$route.params.modId, this.$route.params.branchId, data)
          : ModsService.createBranch(this.$route.params.modId, data);

      promise.then(() => {
        if(this.isEdit) {
          this.$log.info('Saved data')
          AlertService.displayAlert('success', 'pages.mods.branch.messages.saved', 2000)
        }else{
          this.$log.info('Created branch')
          this.cancel();
        }
      }).catch(() => {
        if(this.isEdit) {
          AlertService.displayAlert('error', 'pages.mods.branch.messages.failedToSave', 0)
        }else{
          AlertService.displayAlert('error', 'pages.mods.branch.messages.failedToCreate', 0)
        }
      }).finally(() => {
        this.isLoading = null;
      })
    },
    cancel(){
      this.$router.push(`/mods/${this.$route.params.modId}/branches`)
    }
  },

  mounted() {
    this.loadBranch();
  }
}
</script>

<style scoped>

</style>